import IsStringADate from './IsStringADate';
import FormatDate from './FormatDate';

/**
 * Transforms date strings in a JSON object to a formatted date string.
 * 
 * @param {Object|Array} json - The JSON object or array to transform.
 */
const TransformDatesInJson = (json) => {
    /**
     * Formats dates to locale strings within a JSON object.
     * 
     * @param {Object} jsonObj - The JSON object to format.
     */
    const FormatDatesToLocale = (jsonObj) => {
        for (const key in jsonObj) {
            const value = jsonObj[key];
            if (IsStringADate(value)) {
                const dateOnly = value.length < 11;
                let dateValue = value.replace(' ', 'T');
                if (!dateOnly && !dateValue.endsWith('Z')) {
                    dateValue += 'Z';
                }
                const newDate = new Date(dateValue);
                jsonObj[key] = FormatDate(newDate, dateOnly);
            } else if (key.toLowerCase() === "testresults" && value) {
                const regExp = /\d{4}-\d{2}-\d{2}/;
                let pos = value.search(regExp);
                while (pos > 0) {
                    const dateAsString = value.slice(pos, pos + 10);
                    const newDate = new Date(dateAsString);
                    const newValue = FormatDate(newDate, true);
                    jsonObj[key] = value.slice(0, pos) + newValue + value.slice(pos + 10);
                    pos = jsonObj[key].search(regExp);
                }
            }
        }
    };

    if (Array.isArray(json)) {
        json.forEach(element => FormatDatesToLocale(element));
    } else {
        FormatDatesToLocale(json);
    }
};

/**
 * Formats date strings to locale strings within an array for export.
 * 
 * @param {Array<string>} json - The JSON array to format.
 * @returns {Array<string>} The formatted JSON array.
 */
const FormatDatesToLocaleForExport = (json) => {
    /**
     * Formats a single string date to locale.
     * 
     * @param {string} item - The string to format.
     * @returns {string} The formatted date string.
     */
    const FormatStringDateToLocale = (item) => {
        if (IsStringADate(item)) {
            const newDate = new Date(item);
            return FormatDate(newDate, true);
        }
        return item;
    };

    return json.map(line => {
        const elements = line.split("|");
        return elements.map((element, index) => 
            index > 0 ? "|" + FormatStringDateToLocale(element) : FormatStringDateToLocale(element)
        ).join('');
    });
};

export default TransformDatesInJson;
export { FormatDatesToLocaleForExport };










